<form class="action-form" [formGroup]="searchScenarioUnitForm">
  <tds-form-field>
    <tds-form-field-label>Currency <app-info-icon-tooltip text="Select the currency of your choice. For more info about the Methodology, go to the Menu."></app-info-icon-tooltip></tds-form-field-label>
    <select tds-form-field-item formControlName="currency" (change)="saveUserPreferences()">
      @for (currency of currencies() ; track currency) {
        <option [value]="currency">{{ currency }}</option>
      }
    </select>
  </tds-form-field>

  <div>
    <p class="label">Terms <tds-icon name="info" matTooltip="Select the money vintage of your choice. For more info about the Methodology, go to the Menu." matTooltipPosition="right" size="xs" class="help"/></p>
    <tds-segmented-control [selectedIndex]="loadTermsValue()" (selectedIndexChange)="switchTerm($event)">
      @for(term of terms(); track term) {
        <button tds-segmented-control-option (click)="saveUserPreferences()">
          {{ term }}
        </button>
      }
    </tds-segmented-control>
  </div>

  <tds-form-field class="margin-auto">
    <tds-form-field-label>Year <app-info-icon-tooltip text="Select the year of your choice for real terms. For more info about the Methodology, go to the Menu."></app-info-icon-tooltip></tds-form-field-label>
    <select tds-form-field-item formControlName="year" (change)="saveUserPreferences()">
      @for (year of years(); track year) {
      <option [value]="year">{{ year }}</option>
      }
    </select>
  </tds-form-field>
</form>
